import axios from 'axios';

const baseUrl = process.env.REACT_APP_AWS_API_GATEWAY_URL;
const baseUrlFlow = process.env.REACT_APP_AWS_API_GATEWAY_URL_EXECUTE_FLOW;


export const updateService = (data, accessToken) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            'process': "service_alter",
            'action': "UPDATE",
            "variables": data
        })
    });
};


export const fetchServiceJson = (work_flow, accessToken) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            'process': "company_action_selection_select",
            'action': "SELECT_ID",
            'variables': JSON.stringify({ 'work_flow': work_flow })
        })
    });
};


export const fetchStorages = (id_product_service, accessToken) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            'process': "service_alter",
            'action': "SELECT_STORAGES",
            'variables': JSON.stringify({ 'id_product_service': id_product_service })
        })
    });
};



export const getSelectData = (id_user_action, accessToken) => {
    return axios({
        method: 'POST',
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`
        },
        data: JSON.stringify({
            'process': 'company_action_selection_select',
            'action': 'SELECT_ID',
            'variables': JSON.stringify({
                'work_flow': 'MENU-MEETING'
            })
        })
    })
}

// USE FOR Contacto
export const getContacts = (accessToken) => {
    return axios({
        method: 'POST',
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`
        },
        data: JSON.stringify({
            'process': 'contact_select',
            'action': 'SELECT_ALL_CONTACTS'
        })
    })
}
export const getContactsConcat = (accessToken) => {
    return axios({
        method: 'POST',
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`
        },
        data: JSON.stringify({
            'process': 'contact_select',
            'action': 'SELECT_BY_COMPANY_CONCAT'
        })
    })
}

// USE FOR Oportunidad
export const getOpportunities = (accessToken) => {
    return axios({
        method: 'POST',
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`
        },
        data: JSON.stringify({
            'process': 'commercial_opportunity_select',
            'action': 'SELECT_BY_COMPANY'
        })
    })
}

// USE FOR Acompañamiento/followed_up_by
export const getFollowedUpBy = (accessToken) => {
    return axios({
        method: 'POST',
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`
        },
        data: JSON.stringify({
            'process': 'user_select',
            'action': 'SELECT_BY_COMPANY'
        })
    })
}

export const insertDataService = (data, accessToken) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        },
        data: JSON.stringify({
            process: "commercial_visit_alter",
            action: "INSERT",
            variables: JSON.stringify(data)
        })
    })
};

export const updateDataService = (data, accessToken) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        },
        data: JSON.stringify({
            process: "commercial_visit_alter",
            action: "UPDATE",
            variables: JSON.stringify(data)
        })
    })
};

export const fetchServiceById = (accessToken, id) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            "process": "commercial_visit_select",
            "action": "SELECT_ID",
            "findOne": "true",
            "variables": JSON.stringify({
                'filters': { 'id_unique': { 'value': id } }
            })
        })
    });
};
export const fetchServiceByIdOpportunity = (accessToken, id) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            "process": "commercial_visit_select",
            "action": "SELECT_ID_OPPORTUNITY",
            "variables": JSON.stringify({
                'filters': { 'id_opportunity': { 'value': id } }
            })
        })
    });
};

export const  insertDataAttachment = (data, accessToken) => {
    return axios({
        method: "POST",
        url: baseUrlFlow,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    });
};

